import qs from 'qs';

export const createURL = state => state ? `?${qs.stringify(state)}` : '';

export const searchStateToUrl = searchState =>
    searchState ? createURL(searchState) : '';

export const urlToSearchState = ({search}) =>  qs.parse(search.slice(1));

export const DEBOUNCE_TIME = 400;